/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("variant:changed", function (event) {
  var variant = event.detail.variant;

  // variant が null の場合、Section Rendering API でサーバーから取得を試みる
  if (!variant) {
    fetchVariantFromServer();
    return;
  }

  // variant が見つかった場合: 既存の在庫表示ロジック
  var jsonData = JSON.parse(
    document.querySelector("[data-product-json]").innerHTML
  );
  const variantsInventories = jsonData["inventories"] || {};
  const inventory = variantsInventories[variant.id];

  const productFormInventory = document.querySelector('.ProductForm__Inventory');
  if (productFormInventory && inventory) {
    if (inventory.inventory_management && inventory.inventory_message) {
      productFormInventory.innerHTML = inventory.inventory_message;
      productFormInventory.style.display = '';
    }
  }
});

/**
 * Section Rendering API fallback for products with 250+ variants.
 * When theme.js can't find a variant in the local JSON (returns null),
 * this fetches the server-rendered HTML and swaps in the correct UI elements.
 */
let _variantFetchController = null;

async function fetchVariantFromServer() {
  const productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return;

  const sectionId = productSection.getAttribute('data-section-id');
  const productHandle = productSection.getAttribute('data-product-handle');
  if (!sectionId || !productHandle) return;

  const optionValueIds = getSelectedOptionValueIds();
  if (optionValueIds.length === 0) return;

  // Cancel any in-flight request to prevent stale responses from overwriting newer selections
  if (_variantFetchController) _variantFetchController.abort();
  _variantFetchController = new AbortController();
  const signal = _variantFetchController.signal;

  try {
    // Use Shopify's root URL to support locale-prefixed storefronts (/en, /it, /zh-cn)
    const rootUrl = (window.routes && window.routes.rootUrlWithoutSlash) || '';
    const url = `${rootUrl}/products/${productHandle}?option_values=${optionValueIds.join(',')}&section_id=${sectionId}`;
    const response = await fetch(url, { signal });
    if (!response.ok) return;

    const html = await response.text();

    // If this request was aborted while reading, stop processing
    if (signal.aborted) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Get the selected variant ID from the server-rendered JSON
    const serverJsonEl = doc.querySelector('[data-product-json]');
    if (!serverJsonEl) return;
    const serverData = JSON.parse(serverJsonEl.textContent);
    const selectedVariantId = serverData.selected_variant_id;
    if (!selectedVariantId) return;

    // Verify the server returned a variant matching the requested option values.
    // product.selected_or_first_available_variant may fall back to a different variant
    // if the exact combination doesn't exist. Check by comparing option values in the
    // server-rendered popover/selector against our requested IDs.
    const serverVariant = serverData.product.variants.find(v => v.id === selectedVariantId);
    if (serverVariant) {
      // Variant is in the JSON - verify options match what we requested
      const currentOptions = getCurrentSelectedOptionValues();
      const optionKeys = ['option1', 'option2', 'option3'];
      const mismatch = optionKeys.some((key, i) => {
        return currentOptions[i] && serverVariant[key] && serverVariant[key] !== currentOptions[i];
      });
      if (mismatch) {
        // Server returned a fallback variant, not the one we requested - treat as unavailable
        disableAddToCart(productSection);
        return;
      }
    }
    // If variant is NOT in the JSON (>250), we trust the server's selection since
    // option_values parameter explicitly tells Shopify which combination to select.

    // 1. Update hidden variant ID input (critical for add-to-cart)
    const idInput = productSection.querySelector('input[name="id"]');
    if (idInput) idInput.value = selectedVariantId;

    // Also update master select
    const masterSelect = productSection.querySelector('select[name="id"]');
    if (masterSelect) {
      let opt = masterSelect.querySelector(`option[value="${selectedVariantId}"]`);
      if (!opt) {
        opt = document.createElement('option');
        opt.value = selectedVariantId;
        masterSelect.appendChild(opt);
      }
      masterSelect.value = selectedVariantId;
      opt.setAttribute('selected', 'selected');
    }

    // 2. Swap price list from server HTML
    const serverPriceList = doc.querySelector('.ProductMeta__PriceList');
    const currentPriceList = productSection.querySelector('.ProductMeta__PriceList');
    if (serverPriceList && currentPriceList) {
      currentPriceList.innerHTML = serverPriceList.innerHTML;
      currentPriceList.style.display = '';
    }

    // 3. Swap inventory message from server HTML
    const serverInventory = doc.querySelector('.ProductForm__Inventory');
    const currentInventory = productSection.querySelector('.ProductForm__Inventory');
    if (currentInventory && serverInventory) {
      currentInventory.innerHTML = serverInventory.innerHTML;
      currentInventory.style.display = serverInventory.getAttribute('style')?.includes('display: none') ? 'none' : '';
    } else if (currentInventory && !serverInventory) {
      currentInventory.style.display = 'none';
    }

    // 4. Swap add-to-cart button from server HTML
    const serverBtn = doc.querySelector('.ProductForm__AddToCart');
    const currentBtn = productSection.querySelector('.ProductForm__AddToCart');
    if (serverBtn && currentBtn) {
      currentBtn.innerHTML = serverBtn.innerHTML;
      currentBtn.className = serverBtn.className;
      if (serverBtn.hasAttribute('disabled')) {
        currentBtn.setAttribute('disabled', 'disabled');
        currentBtn.removeAttribute('data-action');
      } else {
        currentBtn.removeAttribute('disabled');
        currentBtn.setAttribute('data-action', 'add-to-cart');
      }
    }

    // 5. Update URL
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('variant', selectedVariantId);
    window.history.replaceState({ path: newUrl.toString() }, '', newUrl.toString());

  } catch (error) {
    if (error.name === 'AbortError') return; // Expected when a newer request supersedes this one
    console.error('Section Rendering API fallback error:', error);
  }
}

/**
 * Get the currently selected option values as strings (e.g., ['#15', '(Jan.) Garnet'])
 * for variant verification.
 */
function getCurrentSelectedOptionValues() {
  const values = [];
  const productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return values;

  const optionPositions = new Set();
  productSection.querySelectorAll('[data-option-position]').forEach(el => {
    optionPositions.add(el.getAttribute('data-option-position'));
  });

  for (const position of [...optionPositions].sort()) {
    const checkedRadio = productSection.querySelector(
      `input[type="radio"][data-option-position="${position}"]:checked`
    );
    if (checkedRadio) { values.push(checkedRadio.value); continue; }

    const selectedBtn = productSection.querySelector(
      `.Popover__Value.is-selected[data-option-position="${position}"]`
    );
    if (selectedBtn) { values.push(selectedBtn.dataset.value); continue; }

    const selectedCarousel = productSection.querySelector(
      `.VariantSelector__Item.is-selected[data-option-position="${position}"]`
    );
    if (selectedCarousel) { values.push(selectedCarousel.dataset.optionValue); continue; }
  }
  return values;
}

/**
 * Show the unavailable state when the requested variant combination doesn't exist.
 */
function disableAddToCart(section) {
  const btn = section.querySelector('.ProductForm__AddToCart');
  if (btn) {
    btn.setAttribute('disabled', 'disabled');
    btn.removeAttribute('data-action');
  }
  const priceList = section.querySelector('.ProductMeta__PriceList');
  if (priceList) priceList.style.display = 'none';
  const inv = section.querySelector('.ProductForm__Inventory');
  if (inv) inv.style.display = 'none';
}

/**
 * Collect selected option value IDs from the DOM.
 * Supports radio inputs (swatch/block), popover buttons, and variant selector carousel.
 */
function getSelectedOptionValueIds() {
  const ids = [];
  const productSection = document.querySelector('[data-section-type="product"]');
  if (!productSection) return ids;

  // Get all option positions that exist
  const optionPositions = new Set();
  productSection.querySelectorAll('[data-option-position]').forEach(el => {
    optionPositions.add(el.getAttribute('data-option-position'));
  });

  for (const position of optionPositions) {
    // 1. Check radio inputs (color swatch, size swatch, block mode)
    const checkedRadio = productSection.querySelector(
      `input[type="radio"][data-option-position="${position}"]:checked`
    );
    if (checkedRadio && checkedRadio.dataset.optionValueId) {
      ids.push(checkedRadio.dataset.optionValueId);
      continue;
    }

    // 2. Check popover buttons (selected state)
    const selectedPopoverBtn = productSection.querySelector(
      `.Popover__Value.is-selected[data-option-position="${position}"]`
    );
    if (selectedPopoverBtn && selectedPopoverBtn.dataset.optionValueId) {
      ids.push(selectedPopoverBtn.dataset.optionValueId);
      continue;
    }

    // 3. Check variant selector carousel (selected item)
    const selectedCarouselItem = productSection.querySelector(
      `.VariantSelector__Item.is-selected[data-option-position="${position}"]`
    );
    if (selectedCarouselItem && selectedCarouselItem.dataset.optionValueId) {
      ids.push(selectedCarouselItem.dataset.optionValueId);
      continue;
    }
  }

  return ids;
}



document.addEventListener("cf:ready", function (event) {
  // prettier-ignore
  const addresses = {"愛知県": "Aichi","秋田県": "Akita","青森県": "Aomori","千葉県": "Chiba","愛媛県": "Ehime","福井県": "Fukui","福岡県": "Fukuoka","福島県": "Fukushima","岐阜県": "Gifu","群馬県": "Gunma","広島県": "Hiroshima","北海道": "Hokkaidō","兵庫県": "Hyōgo","茨城県": "Ibaraki","石川県": "Ishikawa","岩手県": "Iwate","香川県": "Kagawa","鹿児島県": "Kagoshima","神奈川県": "Kanagawa","熊本県": "Kumamoto","京都府": "Kyōto","高知県": "Kōchi","三重県": "Mie","宮城県": "Miyagi","宮崎県": "Miyazaki","長野県": "Nagano","長崎県": "Nagasaki","奈良県": "Nara","新潟県": "Niigata","岡山県": "Okayama","沖縄県": "Okinawa","佐賀県": "Saga","埼玉県": "Saitama","滋賀県": "Shiga","島根県": "Shimane","静岡県": "Shizuoka","栃木県": "Tochigi","徳島県": "Tokushima","鳥取県": "Tottori","富山県": "Toyama","東京都": "Tōkyō","和歌山県": "Wakayama","山形県": "Yamagata","山口県": "Yamaguchi","山梨県": "Yamanashi","大分県": "Ōita","大阪府": "Ōsaka","北海道": "Hokkaidō","青森県": "Aomori","岩手県": "Iwate","宮城県": "Miyagi","秋田県": "Akita","山形県": "Yamagata","福島県": "Fukushima","茨城県": "Ibaraki","栃木県": "Tochigi","群馬県": "Gunma","埼玉県": "Saitama","千葉県": "Chiba","東京都": "Tōkyō","神奈川県": "Kanagawa","新潟県": "Niigata","富山県": "Toyama","石川県": "Ishikawa","福井県": "Fukui","山梨県": "Yamanashi","長野県": "Nagano","岐阜県": "Gifu","静岡県": "Shizuoka","愛知県": "Aichi","三重県": "Mie","滋賀県": "Shiga","京都府": "Kyōto","大阪府": "Ōsaka","兵庫県": "Hyōgo","奈良県": "Nara","和歌山県": "Wakayama","鳥取県": "Tottori","島根県": "Shimane","岡山県": "Okayama","広島県": "Hiroshima","山口県": "Yamaguchi","徳島県": "Tokushima","香川県": "Kagawa","愛媛県": "Ehime","高知県": "Kōchi","福岡県": "Fukuoka","佐賀県": "Saga","長崎県": "Nagasaki","熊本県": "Kumamoto","大分県": "Ōita","宮崎県": "Miyazaki","鹿児島県": "Kagoshima","沖縄県": "Okinawa"}
  document
    .querySelector(`[autocomplete="postal-code"]`)
    .addEventListener("change", async function (event2) {
      try {
        const value = event2.target.value;
        if (value.length !== 7 && value.length !== 8) return;
        const [code1, code2] =
          value.length === 7
            ? [value.slice(0, 3), value.slice(3)]
            : [value.slice(0, 3), value.slice(4)];
        const res = await fetch(
          `https://madefor.github.io/postal-code-api/api/v1/${code1}/${code2}.json`
        );
        const resJson = await res.json();
        const { prefecture, address1, address2 } = resJson.data[0].ja;

        const form = document.querySelector("form[data-cf-form]");
        const cfForm = form.cfForm;
        cfForm.setFieldValue("default_address.province", addresses[prefecture]);
        cfForm.setFieldValue("default_address.city", address1);
        cfForm.setFieldValue("default_address.address1", address2);
        // document.querySelector(`[autocomplete="address-level1"]`).value =
        //   addresses[prefecture];
        // document.querySelector(`[autocomplete="address-level2"]`).value =
        //   address1;
        // document.querySelector(`[autocomplete="address-line1"]`).value =
        //   address2;
      } catch (error) {
        console.error(error);
      }
    });
});
